import { defineStore } from 'pinia'
import { useGlobalStore } from '@/stores/index'
import axios from "axios";
import {useFilterStore} from "@/stores/filter";

// Sample query: https://evgroup-website-typo3.localhost/api/jobs?pid=158&location[in]=4&workField[in]=1&category[in]=11&employment[contains]=1&careerLevel[contains]=2

export const useJobOffersStore = defineStore('jobs', {
  state: () => ({
    jobOffers: []
  }),
  getters: {},
  actions: {
    buildQueryString(arr, prefix) {
      let queryPart = prefix
      for (let i = 0; i < arr.length; i++) {
        queryPart = queryPart + arr[i]
        if ((i+1) < arr.length) {
          queryPart = queryPart + ','
        }
      }
      return queryPart
    },
    getParams(globals, filters) {
      const params = {}
      const selectedLocations = filters.getSelectedLocationUids()
      if (selectedLocations.length > 0) {
        params['location[in]'] = this.buildQueryString(selectedLocations, '')
      }
      const preSelectedWorkField = filters.preSelectedWorkField
      const selectedWorkFields = filters.getSelectedWorkFieldUids()

      if (preSelectedWorkField !== '') {
        params['workField[in]'] = preSelectedWorkField
      } else if (selectedWorkFields.length > 0) {
        params['workField[in]'] = this.buildQueryString(selectedWorkFields, '')
      }
      const selectedCategories = filters.getSelectedCategoryUids()
      if (selectedCategories.length > 0) {
        params['category[in]'] = this.buildQueryString(selectedCategories, '')
      }
      const selectedEmployments = filters.getSelectedEmploymentUids()
      if (selectedEmployments.length > 0) {
        params['employment[contains]'] = this.buildQueryString(selectedEmployments, '')
      }
      const selectedCareerLevels = filters.getSelectedCareerLevelUids()
      if (selectedCareerLevels.length > 0) {
        params['careerLevel[contains]'] = this.buildQueryString(selectedCareerLevels, '')
      }

      params['title[like]'] = filters.getSearchQueryInput()

      return params
    },
    buildStorageObjectsFromAPIResponse(dataArr)
    {
      let tmpStringArr = []
      let tmpDataArr = []
      for (let i = 0; i < dataArr.length; i++) {
        const title = dataArr[i]['title']
        if (tmpStringArr.includes(title)) {
          // find element in tmp data arr and manipulate uid
          let match = tmpDataArr.find(item => item.title === title);
          match['uid'] = match['uid'] + ',' + dataArr[i]['uid']
        } else if (title !== '') {
          tmpStringArr.push(title)
          tmpDataArr.push(dataArr[i])
        }
      }
      return tmpDataArr
    },
    async initAllFilters () {
      const globals = useGlobalStore()
      const filters = useFilterStore()

      let pidQuery = '?pid[in]=' + globals.pidQueryParam

      try {
        // fetching data
        const locations = await axios.get(window.tx_jobs.job_offer_list.api_base + '/job-locations' +
          pidQuery)
        filters.allLocations = this.buildStorageObjectsFromAPIResponse(locations['data'])
        const workFields = await axios.get(window.tx_jobs.job_offer_list.api_base + '/working-field' + pidQuery)
        filters.allWorkFields = this.buildStorageObjectsFromAPIResponse(workFields['data'])
        const jobCategories = await axios.get(window.tx_jobs.job_offer_list.api_base + '/job-categories' + pidQuery)
        filters.allJobCategories = this.buildStorageObjectsFromAPIResponse(jobCategories['data'])
        const employments = await axios.get(window.tx_jobs.job_offer_list.api_base + '/employments' + pidQuery)
        filters.allEmployments = this.buildStorageObjectsFromAPIResponse(employments['data'])
        const careerLevels = await axios.get(window.tx_jobs.job_offer_list.api_base + '/career-levels' + pidQuery)
        filters.allCareerLevels = this.buildStorageObjectsFromAPIResponse(careerLevels['data'])
      } catch (e) {
        // do smth
      }
    },
    async getAllRelevantJobOffers ()
    {
      const globals = useGlobalStore()
      const filters = useFilterStore()
      const params = this.getParams(globals, filters)
      params['pid[in]'] = globals.pidQueryParam

      try {
        // fetching data
        const response = await axios.get(window.tx_jobs.job_offer_list.api_base + '/jobs', { params })
        this.jobOffers = response['data']
        globals.pushStateToUrl()
        return response['data']
      } catch (e) {
        // do smth
      }
    }
  }
})
